/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import * as _ from 'lodash';

function analyticsAvailable() {
  return window.adobeAnalysticsObj !== undefined;
}

function getAnalyticsObjectByOrder(analyticsInfo, s) {
  const analyticsObject = window.adobeAnalysticsObj;
  analyticsObject.clearVars();
  let linkTrackVars = [];
  if(_.has(analyticsInfo, 'action') && analyticsInfo.action){
    analyticsObject.events = analyticsInfo.action;
  }

  if(_.has(analyticsInfo, 'purchaseID') && analyticsInfo.purchaseID){
    analyticsObject.purchaseID = analyticsInfo.purchaseID;
    linkTrackVars.push("purchaseID");
  }

  if(_.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode){
    analyticsObject.currencyCode = analyticsInfo.currencyCode;
    linkTrackVars.push("currencyCode");
  }

  if(_.has(analyticsInfo, 'pageName') && analyticsInfo.pageName){
    analyticsObject.pageName = analyticsInfo.pageName;
    linkTrackVars.push("pageName");
  }

  if(_.has(analyticsInfo, 'products') && analyticsInfo.products){
    analyticsObject.products = analyticsInfo.products;
    linkTrackVars.push("products");
  }

  if(_.has(analyticsInfo, 'agentLdap') && analyticsInfo.agentLdap){
    analyticsObject.eVar1 = analyticsInfo.agentLdap;
    linkTrackVars.push("eVar1");
  }

  if(_.has(analyticsInfo, 'customerGuid') && analyticsInfo.customerGuid){
    analyticsObject.eVar2 = analyticsInfo.customerGuid;
    linkTrackVars.push("eVar2");
  }

  if(_.has(analyticsInfo, 'customerCountryCode') && analyticsInfo.customerCountryCode){
    analyticsObject.eVar4 = analyticsInfo.customerCountryCode;
    linkTrackVars.push("eVar4");
  }

  if(_.has(analyticsInfo, 'totalValue') && analyticsInfo.totalValue){
    analyticsObject.eVar11 = analyticsInfo.totalValue;
    linkTrackVars.push("eVar11");
  }

  if(_.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode){
    analyticsObject.eVar12 = analyticsInfo.currencyCode;
    linkTrackVars.push("eVar12");
  }

  if(_.has(analyticsInfo, 'orderCategory') && analyticsInfo.orderCategory){
    analyticsObject.eVar13 = analyticsInfo.orderCategory;
    linkTrackVars.push("eVar13");
  }

  if(_.has(analyticsInfo, 'orderType') && analyticsInfo.orderType){
    analyticsObject.eVar14 = analyticsInfo.orderType;
    linkTrackVars.push("eVar14");
  }

  if(_.has(analyticsInfo, 'internalOrderType') && analyticsInfo.internalOrderType){
    analyticsObject.eVar15 = analyticsInfo.internalOrderType;
    linkTrackVars.push("eVar15");
  }

  if(_.has(analyticsInfo, 'paymentCategory') && analyticsInfo.paymentCategory){
    analyticsObject.eVar16 = analyticsInfo.paymentCategory;
    linkTrackVars.push("eVar16");
  }

  if(_.has(analyticsInfo, 'paymentType') && analyticsInfo.paymentType){
    analyticsObject.eVar17 = analyticsInfo.paymentType;
    linkTrackVars.push("eVar17");
  }

  if(_.has(analyticsInfo, 'paymentSubType') && analyticsInfo.paymentSubType){
    analyticsObject.eVar25 = analyticsInfo.paymentSubType;
    linkTrackVars.push("eVar25");
  }

  if(_.has(analyticsInfo, 'paymentSource') && analyticsInfo.paymentSource){
    analyticsObject.eVar18 = analyticsInfo.paymentSource;
    linkTrackVars.push("eVar18");
  }

  if(_.has(analyticsInfo, 'marketSegment') && analyticsInfo.marketSegment){
    analyticsObject.eVar19 = analyticsInfo.marketSegment;
    linkTrackVars.push("eVar19");
  }

  if(_.has(analyticsInfo, 'ARROrderTotalWithoutTax') && analyticsInfo.ARROrderTotalWithoutTax){
    analyticsObject.eVar20 = analyticsInfo.ARROrderTotalWithoutTax;
    linkTrackVars.push("eVar20");
  }

  if(_.has(analyticsInfo, 'ARROrderTotalWithTax') && analyticsInfo.ARROrderTotalWithTax){
    analyticsObject.eVar21 = analyticsInfo.ARROrderTotalWithTax;
    linkTrackVars.push("eVar21");
  }

  if(_.has(analyticsInfo, 'orderNumber') && analyticsInfo.orderNumber){
    analyticsObject.eVar22 = analyticsInfo.orderNumber;
    linkTrackVars.push("eVar22");
  }
  if(_.has(analyticsInfo, 'ctaId') && analyticsInfo.ctaId){
    analyticsObject.eVar24 = analyticsInfo.ctaId;
    linkTrackVars.push("eVar24");
  }
  if(_.has(analyticsInfo, 'eduUserType') && analyticsInfo.eduUserType){
    analyticsObject.eVar26 = analyticsInfo.eduUserType;
    linkTrackVars.push("eVar26");
  }
  if(_.has(analyticsInfo, 'offerType') && analyticsInfo.offerType){
    analyticsObject.eVar31 = analyticsInfo.offerType;
    linkTrackVars.push("eVar31");
  }

  if (_.has(analyticsInfo, 'campaignName') && analyticsInfo.campaignName) {
    analyticsObject.eVar112 = analyticsInfo.campaignName;
    linkTrackVars.push('eVar112');
  }

  if(_.has(analyticsInfo, 'promoDiscountType') && analyticsInfo.promoDiscountType){
    analyticsObject.eVar81 = analyticsInfo.promoDiscountType;
    linkTrackVars.push("eVar81");
  }

  if(_.has(analyticsInfo, 'flowSubType') && analyticsInfo.flowSubType){
    analyticsObject.eVar49 = analyticsInfo.flowSubType;
    linkTrackVars.push("eVar49");
  }

  if(_.has(analyticsInfo, 'flowType') && analyticsInfo.flowType){
    analyticsObject.eVar50 = analyticsInfo.flowType;
    linkTrackVars.push("eVar50");
  }
  
  if(_.has(analyticsInfo, 'customerRegion') && analyticsInfo.customerRegion){
    analyticsObject.eVar5 = analyticsInfo.customerRegion;
    linkTrackVars.push("eVar5");
  }

  if(_.has(analyticsInfo, 'agentCallCenter') && analyticsInfo.agentCallCenter){
    analyticsObject.eVar61 = analyticsInfo.agentCallCenter;
    linkTrackVars.push("eVar61");
  }

  if(_.has(analyticsInfo, 'agentPersona') && analyticsInfo.agentPersona){
    analyticsObject.eVar62 = analyticsInfo.agentPersona;
    linkTrackVars.push("eVar62");
  }

  if(_.has(analyticsInfo, 'agentEmployeeType') && analyticsInfo.agentEmployeeType){
    analyticsObject.eVar63 = analyticsInfo.agentEmployeeType;
    linkTrackVars.push("eVar63");
  }

  if(_.has(analyticsInfo, 'agentOrganization') && analyticsInfo.agentOrganization){
    analyticsObject.eVar64 = analyticsInfo.agentOrganization;
    linkTrackVars.push("eVar64");
  }

  if(_.has(analyticsInfo, 'agentChannel') && analyticsInfo.agentChannel){
    analyticsObject.eVar65 = analyticsInfo.agentChannel;
    linkTrackVars.push("eVar65");
  }

  if(_.has(analyticsInfo, 'agentGeolocation') && analyticsInfo.agentGeolocation){
    analyticsObject.eVar66 = analyticsInfo.agentGeolocation;
    linkTrackVars.push("eVar66");
  }

  // agent profile level inbound case
  if (_.has(analyticsInfo, 'agentProfileChannel') && analyticsInfo.agentProfileChannel) {
    analyticsObject.eVar67 = analyticsInfo.agentProfileChannel;
    linkTrackVars.push('eVar67');
  }

  if (_.has(analyticsInfo, 'agentSalesCenter') && analyticsInfo.agentSalesCenter) {
    analyticsObject.eVar69 = analyticsInfo.agentSalesCenter;
    linkTrackVars.push('eVar69');
  }

  if (_.has(analyticsInfo, 'agentSalesGeolocation') && analyticsInfo.agentSalesGeolocation) {
    analyticsObject.eVar70 = analyticsInfo.agentSalesGeolocation;
    linkTrackVars.push('eVar70');
  }

  if (_.has(analyticsInfo, 'agentRepName') && analyticsInfo.agentRepName) {
    analyticsObject.eVar71 = analyticsInfo.agentRepName;
    linkTrackVars.push('eVar71');
  }

  if (_.has(analyticsInfo, 'agentTsm') && analyticsInfo.agentTsm) {
    analyticsObject.eVar72 = analyticsInfo.agentTsm;
    linkTrackVars.push('eVar72');
  }

  if (_.has(analyticsInfo, 'agentTsmLdap') && analyticsInfo.agentTsmLdap) {
    analyticsObject.eVar73 = analyticsInfo.agentTsmLdap;
    linkTrackVars.push('eVar73');
  }

  if (_.has(analyticsInfo, 'agentManager') && analyticsInfo.agentManager) {
    analyticsObject.eVar74 = analyticsInfo.agentManager;
    linkTrackVars.push('eVar74');
  }

  if (_.has(analyticsInfo, 'agentManagerLdap') && analyticsInfo.agentManagerLdap) {
    analyticsObject.eVar75 = analyticsInfo.agentManagerLdap;
    linkTrackVars.push('eVar75');
  }

  if (_.has(analyticsInfo, 'agentFinalTeam') && analyticsInfo.agentFinalTeam) {
    analyticsObject.eVar76 = analyticsInfo.agentFinalTeam;
    linkTrackVars.push('eVar76');
  }

  if (_.has(analyticsInfo, 'agentActiveFlag') && analyticsInfo.agentActiveFlag) {
    analyticsObject.eVar77 = analyticsInfo.agentActiveFlag;
    linkTrackVars.push('eVar77');
  }

  if (_.has(analyticsInfo, 'agentShiftTime') && analyticsInfo.agentShiftTime) {
    analyticsObject.eVar78 = analyticsInfo.agentShiftTime;
    linkTrackVars.push('eVar78');
  }

  if (_.has(analyticsInfo, 'agentTimeZone') && analyticsInfo.agentTimeZone) {
    analyticsObject.eVar79 = analyticsInfo.agentTimeZone;
    linkTrackVars.push('eVar79');
  }

  if (_.has(analyticsInfo, 'agentAgentStartDate') && analyticsInfo.agentAgentStartDate) {
    analyticsObject.eVar80 = analyticsInfo.agentAgentStartDate;
    linkTrackVars.push('eVar80');
  }
  
  if (_.has(analyticsInfo, 'agentTag') && analyticsInfo.agentTag) {
    analyticsObject.eVar122 = analyticsInfo.agentTag;
    linkTrackVars.push('eVar122');
  }
  if (_.has(analyticsInfo, 'supportAgentName') && analyticsInfo.supportAgentName) {
    analyticsObject.eVar123 = analyticsInfo.supportAgentName;
    linkTrackVars.push('eVar123');
  }
  if (_.has(analyticsInfo, 'supportAgentEmployeeType') && analyticsInfo.supportAgentEmployeeType) {
    analyticsObject.eVar124 = analyticsInfo.supportAgentEmployeeType;
    linkTrackVars.push('eVar124');
  }
  if (_.has(analyticsInfo, 'supportAgentEEBusinessUnit') && analyticsInfo.supportAgentEEBusinessUnit) {
    analyticsObject.eVar125 = analyticsInfo.supportAgentEEBusinessUnit;
    linkTrackVars.push('eVar125');
  }
  if (_.has(analyticsInfo, 'supportAgentActiveStatus') && analyticsInfo.supportAgentActiveStatus) {
    analyticsObject.eVar126 = analyticsInfo.supportAgentActiveStatus;
    linkTrackVars.push('eVar126');
  }

  if (_.has(analyticsInfo, 'multiContractOrgId') && analyticsInfo.multiContractOrgId) {
    analyticsObject.eVar95 = analyticsInfo.multiContractOrgId;
    linkTrackVars.push('eVar95');
  }

  if (_.has(analyticsInfo, 'multiContractPlan') && analyticsInfo.multiContractPlan) {
    analyticsObject.eVar101 = analyticsInfo.multiContractPlan;
    linkTrackVars.push('eVar101');
  }

  if (_.has(analyticsInfo, 'agentQuarter') && analyticsInfo.agentQuarter) {
    analyticsObject.eVar121 = analyticsInfo.agentQuarter;
    linkTrackVars.push('eVar121');
  }

  analyticsObject.linkTrackEvents = 'events';
  if (analyticsInfo.arrTotalWithoutTax) {
    analyticsObject.events += `,event1=${analyticsInfo.arrTotalWithoutTax}`;
    linkTrackVars.push("event1");
  }
  if (analyticsInfo.arrTotalWithTax) {
    analyticsObject.events += `,event2=${analyticsInfo.arrTotalWithTax}`;
    linkTrackVars.push("event2");
  }
  if (analyticsInfo.ARROrderTotalWithoutTax) {
    analyticsObject.events += `,event3=${analyticsInfo.ARROrderTotalWithoutTax}`;
    linkTrackVars.push("event3");
  }
  if (analyticsInfo.ARROrderTotalWithTax) {
    analyticsObject.events += `,event4=${analyticsInfo.ARROrderTotalWithTax}`;
    linkTrackVars.push("event4");
  }
  analyticsObject.linkTrackVars = linkTrackVars.join(",");
  analyticsObject.tl();
}

export const trackOrderEvent = function (analyticsInfo) {
  if (analyticsAvailable()) {
    try {
      getAnalyticsObjectByOrder(analyticsInfo);
    } catch (e) {
    }
  }
};

const getAnalyticsObjectVipMpDirectEvent = function (analyticsInfo) {
  const analyticsObject = window.adobeAnalysticsObj;
  analyticsObject.clearVars();
  let linkTrackVars = [];

  if(_.has(analyticsInfo, 'events') && analyticsInfo.events){
    analyticsObject.events = analyticsInfo.events;
    analyticsObject.linkTrackEvents = analyticsInfo.events;
  }


  if(_.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode){
    analyticsObject.currencyCode = analyticsInfo.currencyCode;
    linkTrackVars.push("currencyCode");
  }

  if(_.has(analyticsInfo, 'pageName') && analyticsInfo.pageName){
    analyticsObject.pageName = analyticsInfo.pageName;
    linkTrackVars.push("pageName");
  }

  if(_.has(analyticsInfo, 'agentLdap') && analyticsInfo.agentLdap){
    analyticsObject.eVar1 = analyticsInfo.agentLdap;
    linkTrackVars.push("eVar1");
  }

  if(_.has(analyticsInfo, 'customerGuid') && analyticsInfo.customerGuid){
    analyticsObject.eVar2 = analyticsInfo.customerGuid;
    linkTrackVars.push("eVar2");
  }

  if(_.has(analyticsInfo, 'customerCountryCode') && analyticsInfo.customerCountryCode){
    analyticsObject.eVar4 = analyticsInfo.customerCountryCode;
    linkTrackVars.push("eVar4");
  }

  if(_.has(analyticsInfo, 'customerRegion') && analyticsInfo.customerRegion){
    analyticsObject.eVar5 = analyticsInfo.customerRegion;
    linkTrackVars.push("eVar5");
  }

  if(_.has(analyticsInfo, 'totalValue') && analyticsInfo.totalValue){
    analyticsObject.eVar11 = analyticsInfo.totalValue;
    linkTrackVars.push("eVar11");
  }

  if(_.has(analyticsInfo, 'currencyCode') && analyticsInfo.currencyCode){
    analyticsObject.eVar12 = analyticsInfo.currencyCode;
    linkTrackVars.push("eVar12");
  }

  if(_.has(analyticsInfo, 'orderCategory') && analyticsInfo.orderCategory){
    analyticsObject.eVar13 = analyticsInfo.orderCategory;
    linkTrackVars.push("eVar13");
  }

  if(_.has(analyticsInfo, 'orderType') && analyticsInfo.orderType){
    analyticsObject.eVar14 = analyticsInfo.orderType;
    linkTrackVars.push("eVar14");
  }

  if(_.has(analyticsInfo, 'internalOrderType') && analyticsInfo.internalOrderType){
    analyticsObject.eVar15 = analyticsInfo.internalOrderType;
    linkTrackVars.push("eVar15");
  }


  if(_.has(analyticsInfo, 'offerType') && analyticsInfo.offerType){
    analyticsObject.eVar31 = analyticsInfo.offerType;
    linkTrackVars.push("eVar31");
  }

  if(_.has(analyticsInfo, 'flowType') && analyticsInfo.flowType){
    analyticsObject.eVar49 = analyticsInfo.flowType;
    linkTrackVars.push("eVar49");
  }

  if(_.has(analyticsInfo, 'workFlowId') && analyticsInfo.workFlowId){
    analyticsObject.eVar50 = analyticsInfo.workFlowId;
    linkTrackVars.push("eVar50");
  }

 
  if(_.has(analyticsInfo, 'promoDiscountType') && analyticsInfo.promoDiscountType){
    analyticsObject.eVar81 = analyticsInfo.promoDiscountType;
    linkTrackVars.push("eVar81");
  }

  if(_.has(analyticsInfo, 'isPromoAutoApplied') && analyticsInfo.isPromoAutoApplied){
    analyticsObject.eVar86 = analyticsInfo.isPromoAutoApplied;
    linkTrackVars.push("eVar86");
  }

  if(_.has(analyticsInfo, 'contractId') && analyticsInfo.contractId){
    analyticsObject.eVar94 = analyticsInfo.contractId;
    linkTrackVars.push("eVar94");
  }

  if(_.has(analyticsInfo, 'orgID') && analyticsInfo.orgID){
    analyticsObject.eVar95 = analyticsInfo.orgID;
    linkTrackVars.push("eVar95");
  }

  if(_.has(analyticsInfo, 'action') && analyticsInfo.action){
    analyticsObject.eVar101 = analyticsInfo.action;
    linkTrackVars.push("eVar101");
  }

  if(_.has(analyticsInfo, 'agentQuarter') && analyticsInfo.agentQuarter){
    analyticsObject.eVar121 = analyticsInfo.agentQuarter;
    linkTrackVars.push("eVar121");
  }

  if(_.has(analyticsInfo, 'agentTag') && analyticsInfo.agentTag){
    analyticsObject.eVar122 = analyticsInfo.agentTag;
    linkTrackVars.push("eVar122");
  }

  if(_.has(analyticsInfo, 'supportAgentName') && analyticsInfo.supportAgentName){
    analyticsObject.eVar123 = analyticsInfo.supportAgentName;
    linkTrackVars.push("eVar123");
  }

  if(_.has(analyticsInfo, 'supportAgentEmployeeType') && analyticsInfo.supportAgentEmployeeType){
    analyticsObject.eVar124 = analyticsInfo.supportAgentEmployeeType;
    linkTrackVars.push("eVar124");
  }

  if(_.has(analyticsInfo, 'supportAgentEEBusinessUnit') && analyticsInfo.supportAgentEEBusinessUnit){
    analyticsObject.eVar125 = analyticsInfo.supportAgentEEBusinessUnit;
    linkTrackVars.push("eVar125");
  }

  if(_.has(analyticsInfo, 'supportAgentActiveStatus') && analyticsInfo.supportAgentActiveStatus){
    analyticsObject.eVar126 = analyticsInfo.supportAgentActiveStatus;
    linkTrackVars.push("eVar126");
  }

  if(_.has(analyticsInfo, 'workspaceId') && analyticsInfo.workspaceId){
    analyticsObject.eVar201 = analyticsInfo.workspaceId;
    linkTrackVars.push("eVar201");
  }

  if(_.has(analyticsInfo, 'accountId') && analyticsInfo.accountId){
    analyticsObject.eVar211 = analyticsInfo.accountId;
    linkTrackVars.push("eVar211");
  }


  if(_.has(analyticsInfo, 'discountType') && analyticsInfo.discountType){
    analyticsObject.eVar213 = analyticsInfo.discountType;
    linkTrackVars.push("eVar213");
  }

  if(_.has(analyticsInfo, 'agreementId') && analyticsInfo.agreementId){
    analyticsObject.eVar221 = analyticsInfo.agreementId;
    linkTrackVars.push("eVar221");
  }

  if(_.has(analyticsInfo, 'agreementStatus') && analyticsInfo.agreementStatus){
    analyticsObject.eVar222 = analyticsInfo.agreementStatus;
    linkTrackVars.push("eVar222");
  }

  if(_.has(analyticsInfo, 'agreementSubType') && analyticsInfo.agreementSubType){
    analyticsObject.eVar223 = analyticsInfo.agreementSubType;
    linkTrackVars.push("eVar223");
  }

  analyticsObject.linkTrackVars = linkTrackVars.join(",");
  analyticsObject.tl();
};
export const trackVIPMPDirectEvent = function (analyticsInfo) {
  if (analyticsAvailable()) {
    try {
      getAnalyticsObjectVipMpDirectEvent(analyticsInfo);
    } catch (e) {
    }
  }
};